import styled from 'styled-components';

export const Container = styled.div`
  .simple-product-carousel-item {
    width: 100%;
    max-width: 9rem;
  }

  .simple-product-carousel-item a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 8rem;
    height: 8rem;
    margin-bottom: 0.4rem;
  }

  .item-name {
    text-align: center;
    font-size: 0.7rem;
    color: var(--black);
    font-weight: 500;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .item-price {
    font-size: 1rem;
    color: var(--primary_color);
    font-weight: 900;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 1rem;
    color: var(--primary_color);
  }

  .swiper-button-prev {
    left: -1.6rem;
  }

  .swiper-button-next {
    right: -1.6rem;
  }
`;
